import Deque from './Deque';

export default Deque;
